import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "src/app/http/data.service";
import { authData, removeAuth, saveAuth } from "src/app/util/auth";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-account-dropdown",
  templateUrl: "./account-dropdown.component.html",
})
export class AccountDropdownComponent implements OnInit {
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private dataService: DataService
  ) {}

  _auth = authData();
  _passport = authData("_passport");
  _isApplication = authData("_isApplication");
  links = this._isApplication ? [] : [
    {
      title: "Change Password",
      slug: "/reset-password",
      icon: "password",
    },
    // { title: "News & Updates", slug: "/news", icon: "newspaper" },
  ];

  loading = false;
  notification = {};
  PassportData = "";

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  async ngOnInit(): Promise<void> {
    this.PassportData = await this.dataService.getPassportData();
    if (!this._isApplication && this._auth.IsFamilyLogin) {
      this.links.push({
        title: "Switch Ward Profile",
        slug: "/switch-profile",
        icon: "swap_horiz",
      });
    }
  }

  logoutUser(): void {
    removeAuth();
    this.dataService.clearPassportData();
    this.router.navigateByUrl("/schoolportal/login");
  }
}
